export default {
    artists: {
        artsts_btn: "EXPLORE OUR ARTISTS"
    }
};
